import type { NodeProps } from '@xyflow/react';
import { NodeShell } from './nodeShell';

export function PartyNode({ data, selected }: NodeProps) {
  const d = data as { title?: string; role?: string; vaultLink?: string };
  return (
    <NodeShell title={d.title ?? 'Party'} kind="party" accent="#8b6a00" selected={selected}>
      {d.role && <div style={{ color: '#555' }}>{d.role}</div>}
      {d.vaultLink && <div style={{ marginTop: 2, color: '#0066cc' }}>[[{d.vaultLink}]]</div>}
    </NodeShell>
  );
}
